import Github from './src/github'
export default Github


// WEBPACK FOOTER //
// ./src/components/github/index.js